export default "__VITE_ASSET__gRPg1A6q__"